import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { clips } from "@/mocks/clips";
import { formatViews } from "@/utils/format";

export default function HotRanking() {
  const ranked = [...clips].sort((a, b) => b.hot - a.hot).slice(0, 5);

  return (
    <section className="bg-background-100" id="hot">
      <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="今日高能榜"
          title="讨论度上升最快的五个爆料片段"
          description="榜单按片段在公开平台的讨论量、回看量与弹幕密度综合排序，每小时更新一次。"
        />

        <ol className="flex flex-col gap-3">
          {ranked.map((clip, index) => (
            <li key={clip.id}>
              <Link
                to={`/clip/${clip.id}`}
                className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:flex-row md:items-center md:p-4"
              >
                <div className="flex items-center gap-4">
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                      index === 0
                        ? "bg-primary-500 text-background-50"
                        : index < 3
                          ? "bg-accent-500 text-primary-950"
                          : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="h-[64px] w-[96px] shrink-0 overflow-hidden rounded-md md:h-[72px] md:w-[120px]">
                    <img
                      src={clip.cover}
                      alt={`${clip.title} 高能榜封面`}
                      title={`${clip.title} - 爆料直播高能片段`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                </div>

                <div className="flex flex-1 flex-col gap-1.5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {clip.title}
                  </h3>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-label text-foreground-500">
                    <span>{clip.host}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-play-circle-line" />
                      {formatViews(clip.views)}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {formatViews(clip.comments)}
                    </span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                      热度 {clip.hot}
                    </span>
                  </div>
                </div>

                <div className="hidden w-40 shrink-0 flex-col gap-1.5 lg:flex">
                  <span className="text-xs font-label text-foreground-500">讨论热度</span>
                  <span className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <span
                      className="block h-full rounded-full bg-primary-500"
                      style={{ width: `${clip.hot}%` }}
                    />
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}